import React from "react";
import { useBookingsList } from "../../store/Booking";
import { useError } from "../../store/ErrorModal";

export default function useListBookingPage() {
  const { bookings, fetchBookings } = useBookingsList();

  const [isLoading, setIsLoading] = React.useState<boolean>(true);

  const { onError } = useError();

  const fetchData = React.useCallback(async () => {
    setIsLoading(true);
    try {
      await fetchBookings();
    } catch (error) {
      onError(error as any);
    }
    setIsLoading(false);
  }, [onError, fetchBookings]);

  React.useEffect(() => {
    fetchData();
  }, [fetchData]);

  return { isLoading, bookings };
}
